// Auth session storage for the Supabase client.
// Self-hosted / static deploy: a plain localStorage store is all we need.
export function brokeredPreviewStorage() {
  if (typeof window === "undefined") return undefined;
  return localStorage;
}
